import React, { useState, useEffect } from 'react';
import Spinner from '../../Components/Spinner/Spinner';
import SearchBar from '../../Components/SearchBar/SearchBar';
import {
  scrollToJob,
  handleCollegeMultiDateBookings,
  statusListCollege,
  dateList,
  modeList,
  sortListAll,
  sortListPast,
  filterByDate,
  filterByKeyword,
  filterByStatus,
  filterByMode,
  getRefId, filterByCampus,
} from './Helper';
import { API } from '../../API';
import { teacherResponse } from '../../Helper';
import BookingCardCollege from '../../Components/BookingCard/BookingCardCollege';
import { notify } from 'react-notify-toast';
import {  useParams} from "react-router-dom";
import FormDatePicker from "../../Components/FormField/FormDatePicker";
import moment from "moment";
import JumpToTopButton from "../../Components/Buttons/JumpToTopButton";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterListIcon from '@mui/icons-material/FilterList';
import FormDropdown from "../../Components/FormField/FormDropdown";

function CollegeJobListContents(props) {
  let [isLoaded, setIsLoaded] = useState(false);
  let [allBookings, setAllBookings] = useState([]);
  let [allTeachers, setAllTeachers] = useState([]);
  let [showCurrentBookings, setShowCurrentBookings] = useState([]);
  let [refs, setRefs] = useState({});
  let [searchKeyword, setKeyword] = useState('');
  let [searchDate, setDate] = useState(
    window.location.hash || props.isViewAsAdmin ? 'date-all' : 'future'
  );
  let [searchStatus, setStatus] = useState('status-all');
  let [searchMode, setMode] = useState('mode-all');
  let [searchCampus, setCampus] = useState('campus-all');
  let [sortType, setSortType] = useState('sort-date-desc');
  let [showFilter, setShowFilter] = useState(false)
  let [cancelSingleDay, setCancelSingleDay] = useState(true)
  let [expandDateFilter, setExpandDateFilter] = useState(false)
  let [expandStatusFilter, setExpandStatusFilter] = useState(false)
  let [expandModeFilter, setExpandModeFilter] = useState(false)
  let [expandCampusFilter, setExpandCampusFilter] = useState(false)
  let [expandSortType, setExpandSortType] = useState(false)
  let [showSingleBooking, setShowSingleBooking] = useState(false)

  let sortList = searchDate === 'date-all' ? sortListAll : sortListPast;
  let bookingId;
  let dateIndex;

  useEffect(() => {
    getDateIndex();
    API.getAllTeachersBrief()
      .then((res) => {
        const teachers = res.data
        setAllTeachers(res.data);
        getBookingID();
        if (dateIndex) {
          getBookingByIDandDate(teachers)
          setShowSingleBooking(true)
        } else if (bookingId) {
          getBookingByID(res.data)
          setMode("")
          setDate("")
          setStatus("")
          setShowSingleBooking(true)
        } else {
          getAllBookings(res.data)
          setShowSingleBooking(false)
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getDateIndex();
    if ((expandDateFilter || expandModeFilter || expandCampusFilter || expandStatusFilter) && showSingleBooking) {
      setIsLoaded(false)
      getAllBookings(allTeachers)
      setShowSingleBooking(false)
    }
  }, [expandDateFilter, expandModeFilter, expandCampusFilter, expandStatusFilter, showSingleBooking])

  const getBookingID = () => {
    let pathname = window.location.href;
    let urlArray = pathname.split("#");
    bookingId = urlArray[1]?.split("_")[0];
  }

  const getDateIndex = () => {
    let pathname = window.location.href;
    let urlArray = pathname.split("#");
    dateIndex = urlArray[1]?.split("_")[1];
    if (dateIndex === undefined) {
      setShowFilter(true)
      setCancelSingleDay(false)
    }
  }

  const getBookingByID = (teachers) =>{
    let job;
    API.getBookingByBookingID(bookingId).then((result)=>{
      // result.data is an array.
      job = result.data[0];
      if (job.splits == null || job.splits.length == 0) {
        if (
          job.teacher_id &&
          job.teacher_response === teacherResponse.accepted
        ) {
          job.teacher = teachers.find(
            (teacher) => teacher._id === job.teacher_id
          );
        } else if (
          job.preferred_teacher &&
          job.teacher_response !== teacherResponse.rejected
        ) {
          job.teacher = teachers.find(
            (teacher) => teacher._id === job.preferred_teacher
          );
        } else {
          job.teacher = {};
        }
        let allRefs = { ...refs };
        allRefs[getRefId(job)] = React.createRef();
        setRefs(allRefs);
        setAllBookings([job]);      
        setShowCurrentBookings([job]);
        setIsLoaded(true);
      }
      else {
        let list = handleCollegeMultiDateBookings(result.data);
        list = sort(list, sortType).map((job) => {
          let newJob = { ...job };
          if (
            job.teacher_id &&
            job.teacher_response === teacherResponse.accepted
          ) {
            newJob.teacher = teachers.find(
              (teacher) => teacher._id === job.teacher_id
            );
          } else if (
            job.preferred_teacher &&
            job.teacher_response !== teacherResponse.rejected
          ) {
            newJob.teacher = teachers.find(
              (teacher) => teacher._id === job.preferred_teacher
            );
          } else {
            newJob.teacher = {};
          }
          return newJob;
        });

        list = filterByDate(list, searchDate);
        list = sort(list, "sort-date-asc")

        let allRefs = { ...refs };
        list.forEach((booking) => {
          allRefs[getRefId(booking)] = React.createRef();
        });
        setRefs(allRefs);
        setAllBookings(list);      
        setShowCurrentBookings(list);
        setIsLoaded(true);
        }
    })
    .catch((err) => {
      console.log(err);
    });
   
  }

  const getBookingByIDandDate = (teachers) =>{
    let job;
    API.getBookingByBookingID(bookingId).then((result) => {
      // result.data is an array.
      job = result.data[0];
      let list = handleCollegeMultiDateBookings(result.data);
      list = sort(list, sortType).map((job) => {
        let newJob = {...job};
        if (
          job.teacher_id &&
          job.teacher_response === teacherResponse.accepted
        ) {
          newJob.teacher = teachers.find(
            (teacher) => teacher._id === job.teacher_id
          );
        } else if (
          job.preferred_teacher &&
          job.teacher_response !== teacherResponse.rejected
        ) {
          newJob.teacher = teachers.find(
            (teacher) => teacher._id === job.preferred_teacher
          );
        } else {
          newJob.teacher = {};
        }
        return newJob;
      });

      list = filterByDate(list, job.dates[dateIndex].date);

      let allRefs = {...refs};
      list.forEach((booking) => {
        allRefs[getRefId(booking)] = React.createRef();
      });
      setRefs(allRefs);
      setAllBookings(list);
      setShowCurrentBookings(list);
      // onPickDate(new Date(job.dates[dateIndex].date))
      setIsLoaded(true);
    })
      .catch((err) => {
        console.log(err);
      });
  }

  const getAllBookings = (teachers) => {
    API.getCampusBookingsByInstitutionID(props.institution._id)
      .then((result) => {
        let list = handleCollegeMultiDateBookings(result.data);
        list = sort(list, sortType).map((job) => {
          let newJob = { ...job };
          // console.log(newJob);
          // console.log(job.teacher_id || job.preferred_teacher);
          if (
            job.teacher_id &&
            job.teacher_response === teacherResponse.accepted
          ) {
            newJob.teacher = teachers.find(
              (teacher) => teacher._id === job.teacher_id
            );
          } else if (
            job.preferred_teacher &&
            job.teacher_response !== teacherResponse.rejected
          ) {
            newJob.teacher = teachers.find(
              (teacher) => teacher._id === job.preferred_teacher
            );
          } else {
            newJob.teacher = {};
          }
          return newJob;
        });

        let allRefs = { ...refs };
        list.forEach((booking) => {
          allRefs[getRefId(booking)] = React.createRef();
        });
        setRefs(allRefs);

        setAllBookings(list);
        setIsLoaded(true);

        list = filterByDate(list, searchDate);
        list = sort(list, "sort-date-desc")
        setShowCurrentBookings(list);

      })
      .catch((err) => {
        console.log(err);
      });
  };

  const confirmBookingCancel = (booking, inst_cancelled_reason, wages_percent, dateIndex, selectedDate) => {
    // console.log(booking, inst_cancelled_reason)
    let admin_fee = 0
    let teacherAllocated = booking.teacher && booking.teacher._id && booking.teacher_response === 'accepted';
    
    if (inst_cancelled_reason !== "Public holiday" && teacherAllocated) {
      admin_fee = 50
    }
    if (booking.multiple_date) {
      if(dateIndex) {
        API.splitBookingForCancelSingleDate(booking._id, dateIndex).then((res) => {
          const newBooking = res?.data?.data
          // find splitIndex because the booking already changed
          const splitIndex = newBooking.splits.findIndex(item => 
            item.date_from === selectedDate.date && 
            item.date_to === selectedDate.date 
          )

          API.cancelMultiDateBooking(booking._id, splitIndex, inst_cancelled_reason, wages_percent, admin_fee)
            .then((res) => {
              notify.show('Booking cancelled successfully');
              window.location.reload()
            })
            .catch((err) => {
              console.log(err);
              notify.show(err?.response?.data?.message || 'Error cancelling booking');
            });
          }).catch((err) => {
            console.log(err);
          })
      }
      else {
        API.cancelMultiDateBooking(booking._id, booking.split_index, inst_cancelled_reason, wages_percent, admin_fee)
          .then((res) => {
            notify.show('Booking cancelled successfully');
            window.location.reload()
          })
          .catch((err) => {
            console.log(err);
            notify.show(err?.response?.data?.message || 'Error cancelling booking');
          });
      }
      
    }
    else {
      API.cancelBooking(booking._id, wages_percent, admin_fee)
        .then(() => {
          const newBookings = allBookings;
          const cancelledJobIndex = newBookings.findIndex((b) => {
            return booking._id === b._id;
          });
          newBookings[cancelledJobIndex].cancelled_by_inst = true;
          // console.log(cancelledJobIndex, newBookings[cancelledJobIndex])
          setAllBookings(newBookings);
          search({})
          notify.show('Booking cancelled successfully');
        })
        .catch((err) => {
          console.log(err);
          notify.show('Error cancelling booking');
        });
    }
  };

  const confirmChangeLevel = (booking, updated_level, updatedLevelID) => {
    API.collegeUpdateBookingLevel(booking._id, updated_level, updatedLevelID)
      .then(() => {
        let newBookings = allBookings;
        if (booking.multiple_date) {
          newBookings = allBookings.map((b) => {
            // console.log(`b logged: ${b}`);
            let updatedBooking = b;
            if (b._id === booking._id) {
              // console.log(updatedBooking)
              updatedBooking.level = updated_level?.split("_id:")?.[0];
            }
            return updatedBooking;
          })
        } else {
          const updatedJobIndex = newBookings.findIndex((b) => {
            return booking._id === b._id;
          });
          newBookings[updatedJobIndex].level = updated_level;
          newBookings[updatedJobIndex].class_level_id = updatedLevelID
        }
        setAllBookings(newBookings);
        setShowCurrentBookings(newBookings);
        setIsLoaded(true);
        // search({})
        notify.show('Booking level updated successfully');
      }).catch((err) => {
        console.log(err);
        notify.show('Error updating level');
      })
  }

  // console.log(allTeachers);

  const sort = (list, sType) => {
    // console.log("sorting by: " + sType)
    let sortedList = list;
    switch (sType) {
      case 'sort-date-desc':
        sortedList = list.sort((jobA, jobB) => {
          if (jobA.booking_date === jobB.booking_date) {
            let endBookingDateA = jobA.end_booking_date || jobA.booking_date;
            let endBookingDateB = jobB.end_booking_date || jobB.booking_date;
            if (endBookingDateA === endBookingDateB) {
              return jobA.arrival_time < jobB.arrival_time ? 1 : -1;
            } else return endBookingDateA < endBookingDateB ? 1 : -1;
          } else return jobA.booking_date < jobB.booking_date ? 1 : -1;
        });
        break;
      case 'sort-date-asc':
        sortedList = list.sort((jobA, jobB) => {
          if (jobA.booking_date === jobB.booking_date) {
            let endBookingDateA = jobA.end_booking_date || jobA.booking_date;
            let endBookingDateB = jobB.end_booking_date || jobB.booking_date;
            if (endBookingDateA === endBookingDateB) {
              return jobA.arrival_time > jobB.arrival_time ? 1 : -1;
            } else return endBookingDateA > endBookingDateB ? 1 : -1;
          } else return jobA.booking_date > jobB.booking_date ? 1 : -1;
        });
        break;
      default:
        break;
    }

    return sortedList;
  };

  const search = ({ keyword, status, date, mode, campus }) => {
    const st = status || searchStatus;
    const d = date || searchDate;
    const m = mode || searchMode;
    const c = campus || searchCampus;
    const k = (keyword === undefined ? searchKeyword : keyword).toLowerCase();
    let filteredBookings = filterByStatus(
      allBookings,
      st,
      props.user.customer_id || props.user.personnel_id || props.user._id
    );
    filteredBookings = filterByDate(filteredBookings, d);
    filteredBookings = filterByKeyword(
      filteredBookings,
      k,
      props.campuses,
      [],
      allTeachers
    );
    filteredBookings = filterByMode(filteredBookings, m);
    filteredBookings = filterByCampus(filteredBookings, c, props.campuses)
    if (d === "future" || d === "in-progress") {
      filteredBookings = sort(filteredBookings, "sort-date-asc");
    }
    else filteredBookings = sort(filteredBookings, sortType);
    setShowCurrentBookings(filteredBookings);
  };

  const onSearchStatus = (e) => {
    const status = e.target.id;
    setStatus(status);
    search({ status });
  };

  const onSearchMode = (e) => {
    let mode = e.target.id;
    setMode(mode);
    search({ mode });
  };

  const onSearchCampus = (e) => {
    let campus = e.target.value;
    setCampus(campus);
    search({ campus });
  };

  const onSearchDate = (e) => {
    const date = e.target.id;
    setDate(date);
    search({ date });
  };

  const onPickDate = (date) => {
    setDate(date);
    search({ date });
  }

  const onSearchKeyword = (e) => {
    const keyword = e.target.value;
    setKeyword(keyword);
    search({ keyword });
  };

  const onSort = (e) => {
    const sType = e.target.id;
    setSortType(sType);
    setShowCurrentBookings(sort(showCurrentBookings, sType));
  };

  // console.log(allTeachers);

  return (
    <div className='search-teacher-container'>
      <div className={'search-teacher-filters college-left-menu-width' + (showFilter ? '' : ' d-none')}>
        <div className='w-100 d-flex justify-content-center'>
          <SearchBar
            placeholder='Search...'
            altColours
            onChange={onSearchKeyword}
            value={searchKeyword}
            className=' w-100 justify-content-center'
          />
        </div>
        <div className='d-flex flex-row-reverse cursor-default mt-4'>
          <div>FILTER</div>
          <FilterListIcon />
        </div>
        <hr className='my-3' />
        <div
          onClick={() => setExpandDateFilter(!expandDateFilter)}
          className='row cursor-pointer'
        >
          <h2 className='search-teacher-subheading text-left col-4'>Date</h2>
          <div className='col-6 text-right text-secondary pr-0'>
            {moment(searchDate, "YYYY-MM-DD", true).isValid()
              ? "" : dateList.find(d => { return d.value === searchDate })?.label}
          </div>
          {expandDateFilter ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </div>

        <div hidden={!expandDateFilter} className='my-2 search-teacher-filters-container'>
          <FormDatePicker
            // label=""
            id="pick_date"
            placeholderText="Select date"
            showYearDropdown
            showMonthDropdown
            popperClassName="some-custom-class"
            showPopperArrow={false}
            dropdownMode="select"
            dateFormatCalendar="MMMM"
            dateFormat="yyyy-MM-dd"
            yearDropdownItemNumber={10}
            scrollableYearDropdown
            onChange={(date) => onPickDate(date)}
            selected={moment(searchDate, "YYYY-MM-DD", true).isValid() ? searchDate : ""}
          />
          <ul className='search-teacher-categories'>
            {dateList.map((d) => {
              return (
                <li
                  id={d.value}
                  key={d.value}
                  onClick={onSearchDate}
                  style={{
                    fontWeight: searchDate === d.value ? 'bold' : 'normal',
                  }}
                >
                  {d.label}
                </li>
              );
            })}
          </ul>
        </div>

        <hr className='mb-3' />

        <div
          onClick={() => setExpandStatusFilter(!expandStatusFilter)}
          className='row cursor-pointer'
        >
          <h2 className='search-teacher-subheading text-left col-4'>Status</h2>
          <div className='col-6 text-right text-secondary pr-0'>
            {statusListCollege.find(d => { return d.value === searchStatus })?.label}
          </div>
          {expandStatusFilter ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </div>

        <ul className='search-teacher-categories mb-2 search-teacher-filters-container' hidden={!expandStatusFilter}>
          {statusListCollege.map((st) => {
            return (
              <li
                id={st.value}
                key={st.value}
                onClick={onSearchStatus}
                style={{
                  fontWeight: searchStatus === st.value ? 'bold' : 'normal',
                }}
              >
                {st.label}
              </li>
            );
          })}
        </ul>

        <hr className='mb-3' />

        <div
          onClick={() => setExpandModeFilter(!expandModeFilter)}
          className='row cursor-pointer'
        >
          <h2 className='search-teacher-subheading text-left col-4'>Mode</h2>
          <div className='col-6 text-right text-secondary pr-0'>
            {modeList.find(d => { return d.value === searchMode })?.label}
          </div>
          {expandModeFilter ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </div>

        <ul className='search-teacher-categories mb-2 search-teacher-filters-container' hidden={!expandModeFilter}>
          {modeList.map((mode) => {
            return (
              <li
                id={mode.value}
                key={mode.value}
                onClick={onSearchMode}
                style={{
                  fontWeight: searchMode === mode.value ? 'bold' : 'normal',
                }}
              >
                {mode.label}
              </li>
            );
          })}
        </ul>

        <hr className='mb-3' />

        <div hidden={props.campuses.length <= 1}>
          <div
            onClick={() => setExpandCampusFilter(!expandCampusFilter)}
            className='row cursor-pointer'
          >
            <h2 className='search-teacher-subheading text-left col-4'>Campus</h2>
            <div className='col-6 text-right text-secondary pr-0'>
              {searchCampus === "campus-all" ? "Show All" : searchCampus}
            </div>
            {expandCampusFilter ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>

          <FormDropdown
            id="campus_filter_dropdown"
            className={expandCampusFilter ? "mb-4" : "d-none"}
            onChange={onSearchCampus}
          >
            <option value="campus-all">Show All</option>
            {props.campuses.map((campus) =>
              <option value={campus.reference_name}>
                {campus.address_line1 + (campus.address_line2 ? ', ' + campus.address_line2 : '')}
              </option>)}
          </FormDropdown>

          <hr className='mb-3' />
        </div>

        <div hidden={searchDate === 'future' || searchDate === 'in-progress'}>
          <div
            onClick={() => setExpandSortType(!expandSortType)}
            className='row cursor-pointer'
          >
            <h2 className='search-teacher-subheading text-left col-5'>Sort By</h2>
            <div className='col-5 text-right text-secondary pr-0'>
              {sortList.find(d => { return d.value === sortType })?.label}
            </div>
            {expandModeFilter ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>
          <ul className='search-teacher-categories mb-2 search-teacher-filters-container' hidden={!expandSortType}>
            {sortList.map((s) => {
              return (
                <li
                  id={s.value}
                  key={s.value}
                  onClick={onSort}
                  style={{
                    fontWeight: sortType === s.value ? 'bold' : 'normal',
                  }}
                >
                  {s.label}
                </li>
              );
            })}
          </ul>
          <hr className='mb-3' />
        </div>
      </div>

      <div className='search-teacher-main'>
        {/* <h2 className='search-teacher-heading my-3'>Search Results</h2> */}
        <div className='d-flex flex-wrap justify-content-center'>
          {isLoaded ? (
            showCurrentBookings.length ? (
              showCurrentBookings.map((job, index) => {
                const jobCampus = props.campuses.find(
                  (campus) => campus._id === job.campus_id
                );
                const jobInst = props.institution;
                const classData =
                  props.classes.find(
                    (theClass) => theClass._id === job.class_id
                  ) || {};
                const refId = getRefId(job);
                if(window.location.href.includes("_")) {
                  getDateIndex() // this is required
                }
                
                return (
                  //   new job component goes here
                  <div key={index} className='d-flex align-items-stretch'>
                    <span ref={refs[refId]} className='job-list-ref' />
                    <BookingCardCollege
                      job={job}
                      campus={jobCampus}
                      inst={jobInst}
                      classData={classData}
                      minWidth
                      key={index}
                      cancelSingleDay={cancelSingleDay}
                      confirmBookingCancel={confirmBookingCancel}
                      confirmChangeLevel={confirmChangeLevel}
                      isViewAsTeacher
                      selectedDate={job.dates[dateIndex]}
                      dateIndex={dateIndex}
                    />
                  </div>
                );
              })
            ) : (
              'No results found.'
            )
          ) : (
            <Spinner small />
          )}
        </div>

        {/* {searchResults.length ? (
                        <Pagination
                            itemArray={searchResults}
                            pageNum={pageNum}
                            onPageNumChange={onPageNumChange}
                        />
                    ) : null} */}
      </div>
      <JumpToTopButton />
    </div>
  );
}

export default CollegeJobListContents;
